import React, { createContext, useContext, useMemo } from 'react';
import { usePublicAppContext } from './PublicAppContext';
import { DEFAULT_ZOOM_LEVEL } from '../utils/zoomLevel.js';

const AppShellContext = createContext(null);
AppShellContext.displayName = 'AppShellContext';

const NOOP = () => {};

const useRequiredContext = (Context, name) => {
  const value = useContext(Context);
  if (!value) {
    throw new Error(`${name} must be used within AppProvider`);
  }
  return value;
};

export const AppShellBridgeProvider = ({ children }) => {
  const {
    theme,
    setTheme,
    language,
    setLanguage,
    texts
  } = usePublicAppContext();

  const bridgeValue = useMemo(() => ({
    theme,
    setTheme,
    viewMode: 'list',
    setViewMode: NOOP,
    zoomLevel: DEFAULT_ZOOM_LEVEL,
    setZoomLevel: NOOP,
    isMaximized: false,
    setIsMaximized: NOOP,
    showSettings: false,
    setShowSettings: NOOP,
    showFolderScreen: false,
    setShowFolderScreen: NOOP,
    isLoading: false,
    setIsLoading: NOOP,
    byokKeyRevision: 0,
    texts,
    language,
    setLanguage
  }), [language, setLanguage, setTheme, texts, theme]);

  return (
    <AppShellContext.Provider value={bridgeValue}>
      {children}
    </AppShellContext.Provider>
  );
};

export const useAppShellContext = () => useRequiredContext(AppShellContext, 'AppShellContext');

export { AppShellContext };
